var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgGoalIcon = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 95.5 100",
    style: {
      enableBackground: "new 0 0 95.5 100"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26,54h-2v41l21,3.9c0,0,26.1,2.5,34.3,0c2.6-0.8,7-4.7,8.1-7.1c0.6-1.4-0.2-4.8,0.5-6.2c1-2,5.5-4.6,5.5-7.4 c0-2-2.3-5.4-2.1-7.4c0.2-2,4.3-4.7,4.3-6.7c0-2.1-3.6-5.6-3.3-7.6c0.2-1.6,3.2-4.1,3.3-5.7c0.2-3-3.9-8.9-6.7-10 c-4.4-1.8-26.9-1-26.9-1c-2.2-3.8,3.9-13.3,5.6-17.4c2.5-6,2.1-14-1.1-18c-3.8-5-7.9-4.4-10.9-3.1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20,94c0,2.2-1.8,4-4,4H4c-2.2,0-4-1.8-4-4V56c0-2.2,1.8-4,4-4h12c2.2,0,4,1.8,4,4V94z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGoalIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/goal_icon.f7d17e67.svg";
export { ForwardRef as ReactComponent };